import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Video, Music, Presentation, Image as ImageIcon, X } from "lucide-react";
import { uploadMedia, apiError } from "@/lib/campus";

export const KIND_ICON = { video: Video, audio: Music, slides: Presentation, image: ImageIcon };
const ACCEPT = ".mp4,.mov,.webm,.m4v,.mp3,.m4a,.wav,.ogg,.aac,.pdf,.pptx,.ppt,.key,.jpg,.jpeg,.png,.webp";

export const MediaUploader = ({ media, onChange, testid }) => {
  const input = useRef(null);
  const [progress, setProgress] = useState(null);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setProgress(0);
    try {
      const item = await uploadMedia(file, setProgress);
      onChange([...(media || []), item]);
      toast.success(`${file.name} uploaded`);
    } catch (err) {
      toast.error(apiError(err, "Upload failed — please retry"));
    } finally {
      setProgress(null);
    }
  };

  return (
    <div className="space-y-2" data-testid={testid}>
      {(media || []).map((m, i) => {
        const Icon = KIND_ICON[m.kind] || Upload;
        return (
          <div key={m.path} className="flex items-center gap-2 text-xs bg-white/5 border border-white/10 rounded-lg px-3 py-2">
            <Icon className="h-4 w-4 text-amber-400 shrink-0" />
            <span className="truncate text-slate-200 flex-1">{m.name}</span>
            <span className="text-slate-500 uppercase">{m.kind}</span>
            <button type="button" data-testid={`${testid}-remove-${i}`} onClick={() => onChange(media.filter((_, j) => j !== i))}
              className="text-slate-500 hover:text-red-400"><X className="h-3.5 w-3.5" /></button>
          </div>
        );
      })}
      {progress !== null ? (
        <div className="rounded-lg border border-amber-500/30 bg-amber-500/5 px-3 py-2.5" data-testid={`${testid}-progress`}>
          <div className="flex justify-between text-xs text-amber-300 mb-1.5"><span>Uploading…</span><span>{progress}%</span></div>
          <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
            <div className="h-full bg-amber-500 transition-[width] duration-300" style={{ width: `${progress}%` }} />
          </div>
        </div>
      ) : (
        <button type="button" data-testid={`${testid}-btn`} onClick={() => input.current?.click()}
          className="w-full flex items-center justify-center gap-2 border border-dashed border-white/15 hover:border-amber-500/60 hover:bg-amber-500/5 rounded-lg py-3 text-xs text-slate-300 transition-colors">
          <Upload className="h-4 w-4" /> Add video, audio or slides <span className="text-slate-500">(up to 500 MB)</span>
        </button>
      )}
      <input ref={input} type="file" accept={ACCEPT} className="hidden" onChange={pick} data-testid={`${testid}-input`} />
    </div>
  );
};
